/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpRespDealerDetails_viewer$ref = any;
type PdpRespHeroCarousel_viewer$ref = any;
type PdpRespIconBubblesWrapper_viewer$ref = any;
type PdpRespSeoLinks_viewer$ref = any;
type PdpRespShippingReturns_viewer$ref = any;
type PdpRespSidebarBlurbs_viewer$ref = any;
type PdpRespSidebarButtons_viewer$ref = any;
type PdpRespSidebarContact_viewer$ref = any;
type PdpRespSidebarSellerInfo_viewer$ref = any;
type PdpRespSimilarItemsFooter_viewer$ref = any;
type PdpRespSimilarItemsGridSeller_viewer$ref = any;
type PdpSharedPromoCode_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespContainer_viewer$ref: FragmentReference;
export type PdpRespContainer_viewer = {|
  +isAboutTheMakerEnabled: ?boolean,
  +isFavoritesEnabled: ?boolean,
  +disableMakeOfferContactTest: ?boolean,
  +$fragmentRefs: PdpRespSidebarButtons_viewer$ref & PdpRespSidebarBlurbs_viewer$ref & PdpRespShippingReturns_viewer$ref & PdpRespIconBubblesWrapper_viewer$ref & PdpRespSimilarItemsFooter_viewer$ref & PdpRespSimilarItemsGridSeller_viewer$ref & PdpRespHeroCarousel_viewer$ref & PdpRespSeoLinks_viewer$ref & PdpRespDealerDetails_viewer$ref & PdpRespSidebarContact_viewer$ref & PdpRespSidebarSellerInfo_viewer$ref & PdpSharedPromoCode_viewer$ref,
  +$refType: PdpRespContainer_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespContainer_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchPdp",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSeoLinks_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarButtons_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespShippingReturns_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubblesWrapper_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsFooter_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsGridSeller_viewer",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": "isFavoritesEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "FAVORITES",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"FAVORITES\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespDealerDetails_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarContact_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarSellerInfo_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedPromoCode_viewer",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": "isAboutTheMakerEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "ABOUT_THE_MAKER",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"ABOUT_THE_MAKER\")"
    },
    {
      "kind": "ScalarField",
      "alias": "disableMakeOfferContactTest",
      "name": "isEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "disableMakeOfferContactTest",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabled(key:\"disableMakeOfferContactTest\")"
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchPdp",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "PdpRespHeroCarousel_viewer",
          "args": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '49de96977ed041cdb787b8098a8dd8fb';
module.exports = node;
